module.exports = __webpack_public_path__ + "58c67d93d274d6211eee994d553efc48.jpg";